<template functional>
  <svg
    role="presentation"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="props.size"
    :height="props.size"
    viewBox="0 0 16 16"
  >
    <g transform="translate(-1.7 -1.6)">
      <path
        d="M15.97,5.707a4.434,4.434,0,0,1-6.232,5.622h0L5.844,15.84a1.669,1.669,0,1,1-2.359-2.36L8,9.586a4.434,4.434,0,0,1,5.622-6.232L10.7,6.262l.4,1.964,1.964.4L15.97,5.707Z"
        fill="none"
        stroke="#74788d"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        :style="{ fill: 'none !important' }"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconWrench',

  props: {
    size: { type: [String, Number], default: '16px' },
  }
}
</script>